export enum JobEditorDialogTab {
  JobDetails = 'job_details',
  Application = 'application',
  Process = 'process',
  Team = 'team',
  Referrals = 'referrals',
  SocialSharing = 'social_sharing',
}

export const JobEditorDialogPathsMap: Record<JobEditorDialogTab, string> = {
  [JobEditorDialogTab.JobDetails]: 'job_details',
  [JobEditorDialogTab.Application]: 'application',
  [JobEditorDialogTab.Process]: 'process',
  [JobEditorDialogTab.Team]: 'team',
  [JobEditorDialogTab.Referrals]: 'referrals',
  [JobEditorDialogTab.SocialSharing]: 'social_sharing',
};
